// Module
var code = "<div> <wt-property-grid-table fields=\"vm.properties\" form-controller=\"vm.formController\" item=\"vm.configuration\" modern-design=\"true\"> </wt-property-grid-table> </div>";
// Exports
module.exports = code;